/**
 * RoadmapCommentsSheet
 *
 * Wrapper that shows the roadmap ("Ideas") comments UI via SheetService.
 * Structural sibling of ContentCommentsSheet. Mirrors Flutter's
 * RoadmapCommentsBottomSheet entry point, rendered through the web sheet
 * convention instead of Flutter's hand-rolled draggable overlay.
 */

import { SheetService } from '@/presentation/components/common/sheet/service/SheetService';
import { RoadmapCommentsContent } from './RoadmapCommentsContent';
import type { RoadmapItemEntity } from '@/domain/entities/roadmap/roadmapItemEntity';
import type { RoadmapCommentInfoEntity } from '@/domain/entities/info/roadmapCommentInfoEntity';

export interface ShowRoadmapCommentsSheetParams {
  item: RoadmapItemEntity;
  commentInfo?: RoadmapCommentInfoEntity;
  container?: HTMLElement | string | null;
  screenKey?: string;
  /**
   * Fixed sheet height. The caller must pass this (typically
   * `responsive.bottomSheet.maxHeight`) because this helper is a plain
   * function and cannot read `useResponsiveDesign()` itself.
   */
  fixedHeight?: string;
}

const show = ({
  item,
  commentInfo,
  container,
  screenKey,
  fixedHeight,
}: ShowRoadmapCommentsSheetParams) => {
  SheetService.show({
    title: '',
    content: (
      <RoadmapCommentsContent
        item={item}
        commentInfo={commentInfo}
        screenKey={screenKey}
      />
    ),
    container,
    screenKey,
    fixedHeight,
    scrollable: false,
  });
};

export const RoadmapCommentsSheet = {
  show,
};
